
export const FETCH_VACCINATIONS_LIST = "/api/vaccination/:param/vaccines_list"
export const FETCH_VACCINATIONS_LIST_RABIES = "/api/vaccination_antirabique/:param/vaccination_list_done"
export const CRATE_NEW_MAPI = "/api/mapi/report_mapi/:param/create/:lang/:category"
export const FETCH_MAPI = "/api/mapi/report_mapi/:param/update/:lang/:category"
export const FETCH_MAPI_LIST = "api/medical_folder/:param/mapi/list"
export const FETCH_MAPI_PORTAIL_LIST = "api/medical_folder/:param/mapi_portail/list"
